import { ButtonHTMLAttributes, ReactNode } from 'react'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'accent' | 'primary' | 'secondary' | 'ghost' | 'danger' | 'muted'
  size?: 'sm' | 'md' | 'lg' | 'full'
  icon?: ReactNode
  fullWidth?: boolean
  glow?: boolean
}

export function Button({
  variant = 'accent',
  size = 'md',
  icon,
  fullWidth = false,
  glow = false,
  className = '',
  children,
  ...props
}: Props) {
  const base = 'btn-active inline-flex items-center justify-center gap-2 font-medium rounded-md border-0 cursor-pointer disabled:opacity-40 transition-colors'

  const sizes: Record<string, string> = {
    sm:   'px-3 py-1.5 text-sm',
    md:   'px-4 py-2.5 text-base',
    lg:   'px-5 py-3.5 text-base',
    full: 'px-5 py-3.5 text-base w-full',
  }

  const variants: Record<string, string> = {
    accent:    'btn-accent',
    primary:   'btn-accent',
    secondary: 'bg-surface-2 text-ink border border-line-1',
    ghost:     'bg-surface-2 text-ink',
    danger:    'bg-danger-dim text-danger',
    muted:     'bg-accent-dim text-accent',
  }

  return (
    <button
      className={`${base} ${sizes[size]} ${variants[variant]} ${fullWidth || size === 'full' ? 'w-full' : ''} ${glow ? 'btn-glow' : ''} ${className}`}
      {...props}
    >
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
    </button>
  )
}
